import { render } from "./BasicInfoStep.vue?vue&type=template&id=a442dd92"
import script from "./BasicInfoStep.vue?vue&type=script&lang=ts"
export * from "./BasicInfoStep.vue?vue&type=script&lang=ts"
script.render = render

export default script